import { render, staticRenderFns } from "./RsaPazienteArmadiettoRicevuteModalEditComponent.vue?vue&type=template&id=3e427029"
import script from "./RsaPazienteArmadiettoRicevuteModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteArmadiettoRicevuteModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports